import { useEffect } from "react";
import featureFlag from "../../feature-flag";
import { useCurrentUserSubscriptionTier } from "../../hooks/use-current-user-subscription-tier/use-current-user-subscription-tier";
import useAccessToken from "../../hooks/useAccessToken";
import { detectUserSessionInformation } from "./utils/detect-user-session-information";

function DetectUserSession(): JSX.Element {
  const token = useAccessToken();
  const { currentUserTier } = useCurrentUserSubscriptionTier();

  useEffect(
    function whenUserTokenChange() {
      detectUserSessionInformation(token);
      featureFlag.updateContext(currentUserTier);
    },
    [currentUserTier, token]
  );

  return <></>;
}

export default DetectUserSession;
